export function downloadAsCSV(blob: Blob, fileName: string) {
  const url = window.URL.createObjectURL(blob); // URL für Blob erstellen
  const a = document.createElement('a');
  a.href = url;
  a.download = fileName; // Dateiname angeben
  a.click();
  window.URL.revokeObjectURL(url); // Speicher freigeben
}
